import types from './types';

const initialState = {
  meta: {
    networkAction: false,
    copyingShift: false,
    error: null
  },
  shiftsToBeRemovedByScheduleId: {}, // key is a schedule id, value is an array of shifts to remove
  byWeek: {}, // key is a start of the week (sunday) in format YYYY-MM-DD, value is a schedule id
  byId: {},
  currentScheduleId: '' // wthe id of the schedule for the current visible week
};

export const schedulingReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_CURRENT_WEEK_SCHEDULE_ID: {
      return {
        ...state,
        currentScheduleId: action.scheduleId
      };
    }
    case types.COPY_SCHEDULE_TO_NEW_WEEK_REQUEST:
    case types.PUBLISH_SCHEDULE_REQUEST:
    case types.UNPUBLISH_SCHEDULE_REQUEST:
    case types.SAVE_SHIFTS_TO_SCHEDULE_REQUEST:
    case types.GET_SCHEDULE_FOR_WEEK_REQUEST:
    case types.CREATE_NEW_SCHEDULE_REQUEST: {
      return {
        ...state,
        meta: {
          ...state.meta,
          networkAction: true
        }
      };
    }
    case types.COPY_SCHEDULE_TO_NEW_WEEK_SUCCESS:
    case types.GET_SCHEDULE_FOR_WEEK_SUCCESS:
    case types.CREATE_NEW_SCHEDULE_SUCCESS: {
      let currentScheduleId = state.currentScheduleId;
      const byWeekCopy = { ...state.byWeek };
      const byIdCopy = { ...state.byId };

      if (!action.schedule.scheduleId) {
        currentScheduleId = '';
      } else if (action.schedule && action.schedule.scheduleId) {
        byWeekCopy[action.start] = action.schedule.scheduleId;
        byIdCopy[action.schedule.scheduleId] = action.schedule;
        currentScheduleId = action.schedule.scheduleId;
      }

      // don't change the active schedule id since we aren't navigating to the new schedule after copying
      if (action.type === types.COPY_SCHEDULE_TO_NEW_WEEK_SUCCESS) {
        currentScheduleId = state.currentScheduleId;
      }

      return {
        ...state,
        meta: {
          ...state.meta,
          networkAction: false
        },
        byWeek: byWeekCopy,
        byId: byIdCopy,
        currentScheduleId
      };
    }
    case types.COPY_SCHEDULE_TO_NEW_WEEK_FAILURE:
    case types.SAVE_SHIFTS_TO_SCHEDULE_FAILURE:
    case types.GET_SCHEDULE_FOR_WEEK_FAILURE:
    case types.CREATE_NEW_SCHEDULE_FAILURE: {
      return {
        ...state,
        meta: {
          ...state.meta,
          networkAction: false,
          error: action.error ? action.error.message || '' : ''
        }
      };
    }
    case types.SAVE_SHIFT_TO_WEEK_SCHEDULE: {
      // shifts that have been saved on the front end but not the back end have an id of `[schedule_id]_[Date.now]`
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.scheduleId]: {
            ...state.byId[action.scheduleId],
            shifts: [...state.byId[action.scheduleId].shifts, {
              id: `${action.scheduleId}__${Date.now()}__DRAFT`, // add a custom, temporary id for the front end
              ...action.shift
            }]
          }
        }
      };
    }
    case types.SAVE_SHIFTS_TO_SCHEDULE_SUCCESS: {
      return {
        ...state,
        meta: {
          ...state.meta,
          networkAction: false
        },
        byId: {
          ...state.byId,
          [action.scheduleId]: {
            ...state.byId[action.scheduleId],
            shifts: action.shifts
          }
        },
        shiftsToBeRemovedByScheduleId: {
          ...state.shiftsToBeRemovedByScheduleId,
          [action.scheduleId]: [] // remove any shifts that were queued up for removal
        }
      };
    }
    case types.PUBLISH_SCHEDULE_SUCCESS:
    case types.UNPUBLISH_SCHEDULE_SUCCESS: {
      const schedulePublishStatus = action.type === types.PUBLISH_SCHEDULE_SUCCESS ? 'PUBLISHED' : 'DRAFT';

      return {
        ...state,
        meta: {
          ...state.meta,
          networkAction: false
        },
        byId: {
          ...state.byId,
          [action.scheduleId]: {
            ...state.byId[action.scheduleId],
            publishStatus: schedulePublishStatus
          }
        }
      };
    }
    case types.REMOVE_SHIFTS_FROM_SCHEDULE: {
      const shiftsToBeRemovedByScheduleIdCopy = { ...state.shiftsToBeRemovedByScheduleId };

      // add the shifts that need to be removed to the proper object...
      if (shiftsToBeRemovedByScheduleIdCopy[action.scheduleId]) {
        shiftsToBeRemovedByScheduleIdCopy[action.scheduleId] = shiftsToBeRemovedByScheduleIdCopy[action.scheduleId].concat(action.shifts);
      } else {
        shiftsToBeRemovedByScheduleIdCopy[action.scheduleId] = action.shifts;
      }

      // ... and remove them from the schedule object kept in redux
      const idsToRemove = action.shifts.map(shift => shift.id);

      const updatedShiftsArr = state.byId[action.scheduleId].shifts.map(shift => {
        if (idsToRemove.includes(shift.id)) {
          return {
            ...shift,
            removeShiftId: `${shift}__REMOVE`
          };
        } else {
          return shift;
        }
      });

      return {
        ...state,
        shiftsToBeRemovedByScheduleId: shiftsToBeRemovedByScheduleIdCopy,
        byId: {
          ...state.byId,
          [action.scheduleId]: {
            ...state.byId[action.scheduleId],
            // shifts: state.byId[action.scheduleId].shifts.filter(shift => !idsToRemove.includes(shift.id))
            shifts: updatedShiftsArr
          }
        }
      };
    }
    case types.EDIT_EXISTING_SHIFT: {
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.scheduleId]: {
            ...state.byId[action.scheduleId],
            shifts: state.byId[action.scheduleId].shifts.map(s => s.id === action.shift.id ? action.shift : s)
          }
        }
      };
    }
    case types.COPY_SHIFT_TO_NEW_DATES_REQUEST: {
      return {
        ...state,
        meta: {
          ...state.meta,
          networkAction: true,
          copyingShift: true
        }
      };
    }
    case types.COPY_SHIFT_TO_NEW_DATES_FAILURE:
    case types.COPY_SHIFT_TO_NEW_DATES_SUCCESS: {
      return {
        ...state,
        meta: {
          ...state.meta,
          networkAction: false,
          copyingShift: false
        }
      };
    }
    default:
      return state;
  }
};
